import { FileText, Receipt, Users, Plane } from 'lucide-react'
import { Badge } from '@/components/ui/badge'

interface QuickStatsCardProps {
  documentCount: number
  expenseCount: number
  passengerCount: number
  flightSegmentCount: number
}

export function QuickStatsCard({
  documentCount,
  expenseCount,
  passengerCount,
  flightSegmentCount,
}: QuickStatsCardProps) {
  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-5">
      <h2 className="text-lg font-semibold text-slate-900 mb-4">Übersicht</h2>
      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <span className="flex items-center gap-2 text-slate-600">
            <FileText className="h-4 w-4 text-slate-400" />
            Dokumente
          </span>
          <Badge variant="secondary">{documentCount}</Badge>
        </div>
        <div className="flex items-center justify-between">
          <span className="flex items-center gap-2 text-slate-600">
            <Receipt className="h-4 w-4 text-slate-400" />
            Ausgaben
          </span>
          <Badge variant="secondary">{expenseCount}</Badge>
        </div>
        <div className="flex items-center justify-between">
          <span className="flex items-center gap-2 text-slate-600">
            <Users className="h-4 w-4 text-slate-400" />
            Passagiere
          </span>
          <Badge variant="secondary">{passengerCount}</Badge>
        </div>
        <div className="flex items-center justify-between">
          <span className="flex items-center gap-2 text-slate-600">
            <Plane className="h-4 w-4 text-slate-400" />
            Flüge
          </span>
          <Badge variant="secondary">{flightSegmentCount}</Badge>
        </div>
      </div>
    </div>
  )
}
